import React from 'react'
import { Link as LinkRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

const Link = ({ to, children, target, style, id }, ref) => {
  const internalString = 'webmotors.com.br'

  const isInternalUrl = to.includes(internalString)
  const internalUrlParts = isInternalUrl ? to.split(internalString) : []
  const internalUrl = internalUrlParts[1]
  const url = internalUrl || to

  if (!isInternalUrl)
    return (
      <a href={url} ref={ref} style={style} id={id} target={target}>
        {children}
      </a>
    )

  return (
    <LinkRouter to={url} ref={ref} style={style} id={id}>
      {children}
    </LinkRouter>
  )
}

Link.defaultProps = {
  style: null,
  id: null,
  target: null,
}

Link.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  style: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  id: PropTypes.string,
  target: PropTypes.oneOf(['_blank', '_self', '_parent', '_top']),
}

export default React.forwardRef(Link)
